import { useState, useMemo, useEffect } from 'react';

function useHasBundles() {
  const [bundles, setBundles] = useState(null);

  const hasBundles = useMemo(() => bundles?.length > 2, [bundles]);

  useEffect(() => {
    window?.digitalData?.subscribe('bundles', () => {
      const currentBundles = window?.digitalData?.get('bundles');
      if (currentBundles !== undefined && currentBundles !== null) {
        setBundles(currentBundles);
      }
    });
  }, []);

  return hasBundles;
}

export default useHasBundles;
